import { Hidden } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentFunctionName } from '../../performanceModeManager';
import AffairsAsCards from './AffairsAsCards';
import AffairsAsTable from './AffairsAsTable';

class AffairsList extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let bigScreenElement = <AffairsAsTable {...this.props} />;

        if (!this.props.affairs.displayAsList)
            bigScreenElement = <AffairsAsCards {...this.props} />

        return (
            <>
                <Hidden only={['xl', 'lg', 'md']}>
                    <AffairsAsCards {...this.props} />
                </Hidden>
                <Hidden only={['sm', 'xs']}>
                    {bigScreenElement}
                </Hidden>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        affairs: state.affairs,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AffairsList);
